
import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as supplierService from '@/services/supplierService';
import { toast } from "sonner";

export const useAddSupplierProduct = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: supplierService.addSupplierProduct,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['suppliers'] });
      queryClient.invalidateQueries({ queryKey: ['suppliers', data.supplier_id] });
    },
    onError: (error: Error) => {
      console.error('Error adding supplier product:', error);
      toast.error(`Failed to add supplier product: ${error.message}`);
    }
  });
};

export const useRemoveSupplierProduct = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (params: { supplierId: string, productId: string }) => 
      supplierService.removeSupplierProduct(params.supplierId, params.productId),
    onSuccess: (_, { supplierId }) => {
      queryClient.invalidateQueries({ queryKey: ['suppliers'] });
      queryClient.invalidateQueries({ queryKey: ['suppliers', supplierId] });
    },
    onError: (error: Error) => {
      console.error('Error removing supplier product:', error);
      toast.error(`Failed to remove supplier product: ${error.message}`);
    }
  });
};
